import { Step } from "../types";

export const createStepsMap = <PathType>(steps: Step<PathType>[]) =>
  steps.reduce(
    (acc, step) => {
      acc[step.path as string] = step;
      return acc;
    },
    {} as Record<string, Step<PathType>>
  );
